var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2 text-nowrap"},[_c('span',{class:[_vm.$style.donut, _vm.color === undefined ? _vm.$style[_vm.type] : ''],style:([_vm.color !== undefined ? { borderColor: _vm.color } : {}])}),_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }